import Cookies from 'js-cookie';

import { isDevEnvironmentSwitcherEnabled } from './environments';

const COOKIE_KEY = 'DEV_EMBED_SANDBOX';
const cookieOptions = { path: '/' };

export const EMBED_SANDBOX_COOKIE_KEY = COOKIE_KEY;
export const EMBED_SANDBOX_ENTITY_KEY = 'salesOrders';
export const EMBED_SANDBOX_PORT = 3015;
export const EMBED_SANDBOX_IFRAME_URL = `https://localhost:${EMBED_SANDBOX_PORT}`;

const isLocalHost = (win = window) => {
    const hostname = win?.location?.hostname;
    return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
};

const formatLocalHost = (hostname) => (hostname.includes(':') ? `[${hostname}]` : hostname);

/** Cookie is only honored where Dev Tools is enabled (local dev, staging, pre). */
export const isEmbedSandboxAvailable = () => isDevEnvironmentSwitcherEnabled();

export const isEmbedSandboxEnabled = (win = window) => {
    if (!isEmbedSandboxAvailable(win)) return false;
    return Cookies.get(COOKIE_KEY) === '1';
};

export const setEmbedSandboxEnabled = (enabled, win = window) => {
    if (!isEmbedSandboxAvailable(win)) return;

    if (enabled) {
        Cookies.set(COOKIE_KEY, '1', cookieOptions);
        return;
    }

    Cookies.remove(COOKIE_KEY, cookieOptions);
};

export const getEmbedSandboxIframeUrl = (win = window) => {
    if (!isLocalHost(win)) {
        return EMBED_SANDBOX_IFRAME_URL;
    }

    const protocol = win?.location?.protocol === 'http:' ? 'http:' : 'https:';
    const hostname = win?.location?.hostname || 'localhost';

    return `${protocol}//${formatLocalHost(hostname)}:${EMBED_SANDBOX_PORT}`;
};

export const getEmbedSandboxUnavailableText = (url = EMBED_SANDBOX_IFRAME_URL) => {
    return `Could not load ${url}. Start pnpm start:embed-sandbox and open that URL once to trust the HTTPS certificate.`;
};

export const probeEmbedSandboxUrl = (url, fetchImpl = fetch) => {
    if (!url) return Promise.resolve(false);

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 4000);

    return fetchImpl(url, {
        cache: 'no-store',
        mode: 'no-cors',
        signal: controller.signal,
    })
        .then(
            () => true,
            () => false,
        )
        .finally(() => {
            clearTimeout(timer);
        });
};

export const getEmbedSandboxConfig = (entityKey, win = window) => {
    if (!isEmbedSandboxEnabled(win) || entityKey !== EMBED_SANDBOX_ENTITY_KEY) return null;

    return {
        actions: ['create', 'edit'],
        id: 0,
        sandbox: true,
        url: getEmbedSandboxIframeUrl(win),
    };
};
